import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { t } from "ttag";

import type { ShippingEstimationBarBlock as ShippingEstimationBarBlockValue } from "@reactivated";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    EditableUserLocation,
    ShippingArrivalDate,
    useShippingLocalization,
} from "../ShippingLocalization";

import styles from "./index.module.scss";

export const ShippingEstimationBarBlock = (
    props: Immutable<{ value: ShippingEstimationBarBlockValue }>,
): React.JSX.Element => {
    const localization = useShippingLocalization();
    return (
        <section
            className={concatClassNames([
                styles.shippingEstimator,
                getGlobalSpacingClasses(props.value.spacing),
            ])}
        >
            <div className="main-container">
                <div className={styles.shippingEstimatorProps}>
                    {t`100 Night Trial \u00b7 Free Shipping \u00b7 10 year warranty`}
                </div>
                <p className={styles.shippingEstimatorShipping}>
                    <span
                        className="l10n-fill-shipping-cost"
                        data-prefix={t`Ships for `}
                        data-suffix={t` to `}
                    >
                        {localization.shippingCost
                            ? interpolate(t`Ships for %(shippingCost)s to `, {
                                  shippingCost: localization.shippingCost,
                              })
                            : t`Estimate your ship time:`}
                    </span>{" "}
                    <EditableUserLocation localization={localization} />
                    <ShippingArrivalDate
                        localization={localization}
                        prefix={t`. arrives by `}
                    />
                    .
                </p>
            </div>
        </section>
    );
};
